import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import assign from 'lodash/assign'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import flatten from 'lodash/flatten'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import groupBy from 'lodash/groupBy'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import indexOf from 'lodash/indexOf'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import isEmpty from 'lodash/isEmpty'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import map from 'lodash/map'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import mapValues from 'lodash/mapValues'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import reduce from 'lodash/reduce'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import values from 'lodash/values';
import { getEntityType, getId, getProductType } from '@nerdwallet/marketplace/selectors/common';
import { ENTITY_TYPES_CONFIG, ENTITY_TYPES_ORDERING, PRODUCT_TYPES_CONFIG, WP_ENTITY_PROPS_WHITELIST } from './constants';
import serviceHTTPHelper from '../service-http-helper';
var WP_API_NAMESPACE = 'nw';
var WP_API_VERSION = 1;
/**
 * Additional Data SDK.
 *
 * @param {Object} ServiceSDK - A base ServiceSDK to use.
 * @param {Object} config
 * @param {string} config.wpApiBaseUrl - The WP API base url.
 *
 * @return {Object} - The Additional Data SDK instance.
 */

var AdditionalDataSDK = function AdditionalDataSDK(_ref) {
  var ServiceSDK = _ref.ServiceSDK,
      config = _objectWithoutProperties(_ref, ["ServiceSDK"]);

  if (!config || _typeof(config) !== 'object') {
    throw new Error('A config object is required to initialize AdditionalDataSDK');
  } else if (!config.wpApiBaseUrl) {
    throw new Error('config.wpApiBaseUrl is required to initialize AdditionalDataSDK');
  }
  /**
   * Build a route for a given endpoint.
   *
   * @param {string} endpoint - Endpoint to use.
   *
   * @return {string} - API route.
   */


  var routeBuilder = function routeBuilder(endpoint) {
    return ServiceSDK.nwApiRoute(config.wpApiBaseUrl, WP_API_NAMESPACE, WP_API_VERSION, "".concat(endpoint, "/"));
  };
  /**
   * Response handler.
   *
   * The default handler returns response.data, but we want to include
   * the full response.
   *
   * @type {Object}
   */


  var responseHandler = {
    dataParser: function dataParser(response) {
      return response;
    }
  };
  /**
   * Service to query WP for additional data.
   *
   * @type {Object}
   */

  var service = serviceHTTPHelper(ServiceSDK, routeBuilder, responseHandler);
  /**
   * Get additional data entities.
   *
   * @param {Object} options
   * @param {string} options.productType - Product type.
   * @param {string} options.entityType - Entity type.
   * @param {Array}  options.ids - Marketplace UUID's for which to fetch additional data.
   * @param {Object} options.serverRequest - Original server request.
   *
   * @return {Array} - Additional data response from WP.
   */

  var getAdditionalDataEntities = function getAdditionalDataEntities(_ref2) {
    var productType = _ref2.productType,
        entityType = _ref2.entityType,
        _ref2$ids = _ref2.ids,
        ids = _ref2$ids === void 0 ? [] : _ref2$ids,
        serverRequest = _ref2.serverRequest;
    var endpoint = get(PRODUCT_TYPES_CONFIG, [productType, 'wp', entityType, 'endpoint']);

    if (!endpoint) {
      // Resolve with empty additional data array
      return Promise.resolve([]);
    }

    return service.get(endpoint, {
      marketplace_uuid: ids.join(),
      per_page: ids.length
    }, serverRequest);
  };
  /**
   * Get a collection of nested marketplace entity ids, product types, and entity types from a flat array of marketplace
   * entities, namespaced by the nested entity type and product type.
   *
   * @param  {Array} marketplaceEntities  Array of marketplace entities
   *
   * @return {Object}                     marketplace entity IDs, product type & entity type keyed by PRODUCT_TYPE-ENTITY_TYPE
   */


  var collectNestedEntities = function collectNestedEntities(marketplaceEntities) {
    var _collectNestedEntities = function _collectNestedEntities(result, entity) {
      if (!entity) return result;
      var entityType = getEntityType(entity);
      var productType = getProductType(entity);
      var group = "".concat(productType, "-").concat(entityType);
      /**
       * Additional data is batch fetched by id on the basis of entity type & product type.
       * Construct an object on those groups whose values are the entities themselves.
       *
       * The name of each group is arbitrary, as the info used to calculate the group
       * can be derived from each entity. For example,
       * {
       *    "banking-offers": [{ id: "8fed", entity_type: "offers" , product_type: "banking" }],
       *    "banking-products": [{ id: "92fe", entity_type: "products" , product_type: "banking" }],
       * }
       */

      result[group] = [].concat(_toConsumableArray(result[group] || []), [entity]); // Grab next nested entity in sequence

      var currentEntityDepth = indexOf(ENTITY_TYPES_ORDERING, entityType);
      var nextEntityPath = get(ENTITY_TYPES_CONFIG, [ENTITY_TYPES_ORDERING[currentEntityDepth + 1], 'singular']);
      var nestedEntity = get(entity, nextEntityPath);
      return _collectNestedEntities(result, nestedEntity);
    };

    return reduce(marketplaceEntities, _collectNestedEntities, {});
  };
  /**
   * Transforms Array of additional data entries into Object keyed by entity ID
   *
   * @param  {Array} additionalDataResponse Array of additional data entries
   *
   * @return {Object}                        Entries keyed by entity ID
   */


  var indexAdditionalDataEntities = function indexAdditionalDataEntities(additionalDataResponse) {
    return additionalDataResponse.reduce(function (indexedEntities, entity) {
      // The key the UUID is under has changed. The fallback
      // handling here can be removed once WP has been updated.
      var fallbackUUID = get(entity, ["".concat(entity.type, "_data"), 'marketplace_uuid']);
      var UUID = get(entity, ['nw_data', 'marketplace_uuid'], fallbackUUID);
      indexedEntities[UUID] = entity;
      return indexedEntities;
    }, {});
  };
  /**
   * Augments a single marketplace entity with the additional data entry
   *
   * @param  {object} entity                     Marketplace entity
   * @param  {object} matchingAdditionalDataItem Additional data item
   *
   * @return {object}                            Augmented marketplace entity with `additional_data` key
   */


  var augmentMarketplaceEntityWithAdditionalData = function augmentMarketplaceEntityWithAdditionalData(entity, matchingAdditionalDataItem) {
    if (!entity) return entity;
    var additionalData;

    if (!matchingAdditionalDataItem) {
      additionalData = null;
    } else {
      // The key the WP data is under has changed. The fallback
      // handling here can be removed once WP has been updated.
      var fallbackWPData = get(matchingAdditionalDataItem, "".concat(matchingAdditionalDataItem.type, "_data"));
      var wpData = get(matchingAdditionalDataItem, 'nw_data', fallbackWPData); // Merge whitelisted top-level props with canonical additional data object.

      additionalData = assign({}, WP_ENTITY_PROPS_WHITELIST.reduce(function (propsObj, prop) {
        return assign({}, propsObj, _defineProperty({}, prop, get(matchingAdditionalDataItem, prop)));
      }, {}), wpData);
    }

    return _objectSpread({}, entity, {
      additional_data: additionalData
    });
  };
  /**
   * Augments a single marketplace entity with its nested additional data entries
   *
   * @param  {Object} entity                Marketplace entity
   * @param  {Object} additionalDataItems   Collection of retrieved additional data objects
   *
   * @return {Object}                       Augmented marketplace entity with `additional_data` keys at each entity level
   */


  var augmentMarketplaceEntityWithNestedAdditionalData = function augmentMarketplaceEntityWithNestedAdditionalData(entity, additionalDataItems) {
    var currentEntityId = getId(entity);
    var entityType = getEntityType(entity);
    var productType = getProductType(entity);
    var currentEntityDepth = indexOf(ENTITY_TYPES_ORDERING, entityType);
    var hasAdditionalDataSupport = !!get(PRODUCT_TYPES_CONFIG, [productType, 'wp', entityType, 'endpoint']);
    var augmentedEntity = entity; // don't augment with `additional_data` if support doesn't exist for consistency

    if (hasAdditionalDataSupport) {
      var additionalDataEntity = get(additionalDataItems, currentEntityId);
      augmentedEntity = augmentMarketplaceEntityWithAdditionalData(entity, additionalDataEntity);
    } // Grab next nested entity in sequence


    var nextEntityPath = get(ENTITY_TYPES_CONFIG, [ENTITY_TYPES_ORDERING[currentEntityDepth + 1], 'singular']);
    var nestedEntity = get(augmentedEntity, nextEntityPath);

    if (!nestedEntity) {
      return augmentedEntity;
    }

    return _objectSpread({}, augmentedEntity, _defineProperty({}, nextEntityPath, augmentMarketplaceEntityWithNestedAdditionalData(nestedEntity, additionalDataItems)));
  };
  /**
   * Merge a marketplace search response with an additional data response.
   *
   * @param {Object} options
   * @param {Object} options.marketplaceResponse - The Marketplace response.
   * @param {Array} options.additionalDataResponse - The additional data response.
   * @param {string} options.entityType - The entity type.
   * @param {boolean} options.includeNestedAdditionalData - Flag to fetch additional data
   *    for supported entities up the Offer-Product-Institution chain.
   *
   * @return {Object} - The augmented Marketplace response.
   */


  var augmentMarketplaceSearchResponseWithAdditionalData = function augmentMarketplaceSearchResponseWithAdditionalData(_ref3) {
    var marketplaceResponse = _ref3.marketplaceResponse,
        additionalDataResponse = _ref3.additionalDataResponse,
        entityType = _ref3.entityType,
        includeNestedAdditionalData = _ref3.includeNestedAdditionalData;

    if (!Array.isArray(additionalDataResponse)) {
      throw new Error('additional data response is invalid');
    } // Index additional data entities by associated Marketplace UUID.


    var indexedAdditionalDataEntities = indexAdditionalDataEntities(additionalDataResponse); // Get the 'namespace' (offers, products, institutions) that the entities can be found under in the response

    var marketplaceNamespace = get(ENTITY_TYPES_CONFIG, [entityType, 'namespace']);
    return _objectSpread({}, marketplaceResponse, {
      data: _objectSpread({}, marketplaceResponse.data, _defineProperty({}, marketplaceNamespace, marketplaceResponse.data[marketplaceNamespace].map(function (entity) {
        return includeNestedAdditionalData ? augmentMarketplaceEntityWithNestedAdditionalData(entity, indexedAdditionalDataEntities) : augmentMarketplaceEntityWithAdditionalData(entity, indexedAdditionalDataEntities[get(entity, 'id')]);
      })))
    });
  };
  /**
   * Merge a marketplace by_id response with an additional data response.
   *
   * @param {Object} options
   * @param {Object} options.marketplaceResponse - The Marketplace response.
   * @param {Array} options.additionalDataResponse - The additional data response.
   * @param {string} options.entityType - The entity type.
   * @param {boolean} options.includeNestedAdditionalData - Flag to fetch additional data
   *    for supported entities up the Offer-Product-Institution chain.
   *
   * @return {Object} - The augmented Marketplace response.
   */


  var augmentMarketplaceByIdResponseWithAdditionalData = function augmentMarketplaceByIdResponseWithAdditionalData(_ref4) {
    var marketplaceResponse = _ref4.marketplaceResponse,
        additionalDataResponse = _ref4.additionalDataResponse,
        includeNestedAdditionalData = _ref4.includeNestedAdditionalData;

    if (!Array.isArray(additionalDataResponse)) {
      throw new Error('additional data response is invalid');
    } // Index additional data entities by associated Marketplace UUID.


    var indexedAdditionalDataEntities = indexAdditionalDataEntities(additionalDataResponse);
    return _objectSpread({}, marketplaceResponse, {
      data: mapValues(marketplaceResponse.data, function (entity) {
        return includeNestedAdditionalData ? augmentMarketplaceEntityWithNestedAdditionalData(entity, indexedAdditionalDataEntities) : augmentMarketplaceEntityWithAdditionalData(entity, indexedAdditionalDataEntities[get(entity, 'id')]);
      })
    });
  };
  /**
   * Get additional data for all entities in batches by group.
   *
   * @param {Object} groupedEntities Grouped Marketplace entities for which to fetch additional data.
   * @param {Object} serverRequest   Original server request.
   *
   * @return {Promise} WordPress responses with additional data post objects.
   */


  var getAdditionalDataEntitiesByGroup = function getAdditionalDataEntitiesByGroup(groupedEntities, serverRequest) {
    return Promise.all(map(groupedEntities, function (entities) {
      return getAdditionalDataEntities({
        productType: getProductType(entities[0]),
        entityType: getEntityType(entities[0]),
        ids: map(entities, 'id'),
        serverRequest: serverRequest
      });
    })).then(function (additionalDataResponses) {
      return flatten(additionalDataResponses);
    }).catch(function (err) {
      throw err;
    });
  };
  /**
   * Gets and attaches additional data for a marketplace 'search' response. This response should
   * always contain a single entity and product type.
   *
   * @param {Object} options
   * @param {Promise} options.marketplaceResponse - The marketplace api response.
   * @param {string} options.productType - The product type to fetch.
   * @param {string} options.entityType - The entity type to fetch.
   * @param {Object} options.serverRequest - The original server request.
   * @param {boolean} options.includeNestedAdditionalData - Flag to fetch additional data
   *    for supported entities up the Offer-Product-Institution chain.
   *
   * @return {Object} - Marketplace response augmented with additional data.
   */


  var getAdditionalDataForMarketplaceSearchResponse = function getAdditionalDataForMarketplaceSearchResponse(_ref5) {
    var marketplaceResponse = _ref5.marketplaceResponse,
        productType = _ref5.productType,
        entityType = _ref5.entityType,
        serverRequest = _ref5.serverRequest,
        includeNestedAdditionalData = _ref5.includeNestedAdditionalData;
    var marketplaceNamespace = get(ENTITY_TYPES_CONFIG, [entityType, 'namespace']);
    var marketplaceEntities = get(marketplaceResponse, ['data', marketplaceNamespace]);
    var fetchAdditionalDataPromise;

    if (includeNestedAdditionalData) {
      var groupedEntities = collectNestedEntities(marketplaceEntities);
      fetchAdditionalDataPromise = getAdditionalDataEntitiesByGroup(groupedEntities, serverRequest);
    } else {
      var additionalDataIds = marketplaceEntities.map(function (entity) {
        return entity.id;
      });
      fetchAdditionalDataPromise = getAdditionalDataEntities({
        productType: productType,
        entityType: entityType,
        ids: additionalDataIds,
        serverRequest: serverRequest
      });
    }

    return fetchAdditionalDataPromise.then(function (additionalDataResponse) {
      return augmentMarketplaceSearchResponseWithAdditionalData({
        marketplaceResponse: marketplaceResponse,
        additionalDataResponse: additionalDataResponse,
        entityType: entityType,
        includeNestedAdditionalData: includeNestedAdditionalData
      });
    });
  };
  /**
   * Gets and attaches additional data for a 'by_id' marketplace response.
   * This response can contain entities for different productTypes or entityTypes, so all must
   * be handled.
   *
   * @param {Object} options
   * @param {Promise} options.marketplaceResponse - The marketplace api response.
   * @param {Object} options.serverRequest - The original server request.
   * @param {boolean} options.includeNestedAdditionalData - Flag to fetch additional data
   *    for supported entities up the Offer-Product-Institution chain.
   *
   * @return {Object} - Marketplace response augmented with additional data.
   */


  var getAdditionalDataForMarketplaceByIdResponse = function getAdditionalDataForMarketplaceByIdResponse(_ref6) {
    var marketplaceResponse = _ref6.marketplaceResponse,
        serverRequest = _ref6.serverRequest,
        includeNestedAdditionalData = _ref6.includeNestedAdditionalData;
    var marketplaceEntities = values(marketplaceResponse.data);
    var groupedEntities = includeNestedAdditionalData ? collectNestedEntities(marketplaceEntities) : groupBy(marketplaceEntities, function (entity) {
      return "".concat(getProductType(entity), "-").concat(getEntityType(entity));
    });
    return getAdditionalDataEntitiesByGroup(groupedEntities, serverRequest).then(function (additionalDataResponse) {
      return augmentMarketplaceByIdResponseWithAdditionalData({
        marketplaceResponse: marketplaceResponse,
        additionalDataResponse: additionalDataResponse,
        includeNestedAdditionalData: includeNestedAdditionalData
      });
    });
  };
  /**
   * Get Marketplace data with additional data when additional data ids are NOT known.
   * This includes the following steps:
   *   1. Fetch marketplace data entities
   *   2. Extract associated additional data ids
   *   3. Fetch additional data entities
   *   4. Munge marketplace and additional data
   *
   * @param {Object} options
   * @param {Promise} options.fetchMarketplaceData - The Marketplace fetch Promise to use.
   * @param {string} options.productType - The product type to fetch.
   * @param {string} options.entityType - The entity type to fetch.
   * @param {Object} options.serverRequest - The original server request.
   * @param {boolean} options.includeNestedAdditionalData - Flag to fetch additional data
   *    for supported entities up the Offer-Product-Institution chain.
   *
   * @return {Object} - Marketplace response augmented with additional data.
   */


  var getMarketplaceDataWithAdditionalDataInSequence = function getMarketplaceDataWithAdditionalDataInSequence(_ref7) {
    var entityType = _ref7.entityType,
        fetchMarketplaceData = _ref7.fetchMarketplaceData,
        includeNestedAdditionalData = _ref7.includeNestedAdditionalData,
        productType = _ref7.productType,
        serverRequest = _ref7.serverRequest;
    return fetchMarketplaceData.then(function (marketplaceResponse) {
      if (entityType && productType) {
        return getAdditionalDataForMarketplaceSearchResponse({
          marketplaceResponse: marketplaceResponse,
          productType: productType,
          entityType: entityType,
          serverRequest: serverRequest,
          includeNestedAdditionalData: includeNestedAdditionalData
        });
      }

      return getAdditionalDataForMarketplaceByIdResponse({
        marketplaceResponse: marketplaceResponse,
        serverRequest: serverRequest,
        includeNestedAdditionalData: includeNestedAdditionalData
      });
    });
  };
  /**
   * Get Marketplace data with additional data added.
   *
   * @param {Object} options
   * @param {Promise} options.fetchMarketplaceData - The Marketplace fetch Promise to use.
   * @param {string} options.productType - The product type to fetch.
   * @param {string} options.entityType - The entity type to fetch.
   * @param {Array} options.ids - Marketplace UUIDs for which to fetch additional data.
   * @param {Object} options.serverRequest - The original server request.
   * @param {boolean} options.includeNestedAdditionalData - Flag to fetch additional data
   *    for supported entities up the Offer-Product-Institution chain. Necessitates sequential fetch.
   *
   * @return {Object} - Marketplace response augmented with additional data.
   */


  var getMarketplaceDataWithAdditionalData = function getMarketplaceDataWithAdditionalData(_ref8) {
    var additionalDataIds = _ref8.additionalDataIds,
        entityType = _ref8.entityType,
        fetchMarketplaceData = _ref8.fetchMarketplaceData,
        includeNestedAdditionalData = _ref8.includeNestedAdditionalData,
        productType = _ref8.productType,
        serverRequest = _ref8.serverRequest;

    // Get Marketplace data in a sequence since we don't have (all of the) additionalIds
    if (isEmpty(additionalDataIds) || includeNestedAdditionalData || !productType || !entityType) {
      return getMarketplaceDataWithAdditionalDataInSequence({
        entityType: entityType,
        fetchMarketplaceData: fetchMarketplaceData,
        includeNestedAdditionalData: includeNestedAdditionalData,
        productType: productType,
        serverRequest: serverRequest
      });
    } // Fetch additional data in parallel


    var fetchAdditionalData = getAdditionalDataEntities({
      productType: productType,
      entityType: entityType,
      ids: additionalDataIds,
      serverRequest: serverRequest
    });
    var promises = [fetchMarketplaceData, fetchAdditionalData];
    return Promise.all(promises).then(function (responses) {
      return augmentMarketplaceSearchResponseWithAdditionalData({
        marketplaceResponse: responses[0],
        additionalDataResponse: responses[1],
        entityType: entityType
      });
    }).catch(function (err) {
      throw err;
    });
  };

  return {
    getMarketplaceDataWithAdditionalData: getMarketplaceDataWithAdditionalData
  };
};

export default AdditionalDataSDK;